import axios from './axios';

export const fetchBinders = async username => {
    const response = await axios.get(`/binders/${username}`);
    return response.data;
};

export const fetchBinder = async (username, binderNumber) => {
    const response = await axios.get(`/binders/${username}/${binderNumber}`);
    return response.data;
};

export const createBinder = async title => {
    const response = await axios.post('/binders', { title });
    return response.data;
};

export const updateBinder = async (binderID, title) => {
    const response = await axios.put(`/binders/${binderID}`, { title });
    return response.data;
};

export const deleteBinder = async binderID => {
    await axios.delete(`/binders/${binderID}`);
};

export const addCardToBinder = async (binderID, cardID, slotPosition, displayKey, cardInventoryID) => {
    const response = await axios.post(`/binders/${binderID}/cards`, {
        cardID,
        slotPosition,
        displayKey,
        cardInventoryID,
    });
    return response.data;
};

export const reorderBinderCards = async (binderID, slots) => {
    const response = await axios.put(`/binders/${binderID}/cards`, { slots });
    return response.data;
};

export const removeCardFromBinder = async (binderID, binderCardID) => {
    await axios.delete(`/binders/${binderID}/cards/${binderCardID}`);
};
